<template>
    <div>
        <card>
            <card-header><strong>Update Subscription</strong></card-header>
            <card-body v-if="loading">
                <card-spinner></card-spinner>
            </card-body>
            <card-body class="pt-0">
                <div class="alert alert-warning mb-0" v-if="activePlan">You have cancelled your subscription to the<b
                        class="text-capitalize"> {{ activePlan.nickname }} / {{ activePlan.interval |
                    interval(activePlan.interval_count) }}</b> plan with a limit of<b> {{ team.locations_limit }}</b>
                    location(s). The
                    benefits of your subscription will continue until your current billing period ends on<b> {{
                        activeSubscription.ends_at | date }}</b>. {{ resumeOperationText }}
                </div>
            </card-body>
            <select-stripe-plans :plans="plans" :plan-id.sync="planForm.plan"
                                 :locations-limit.sync="planForm.locations_limit" v-if="!loading"></select-stripe-plans>
            <card-body class="pt-0" v-if="planForm.errors.has('plan')">
                <div class="alert alert-danger mb-0">{{ planForm.errors.get('plan') }}</div>
            </card-body>
            <card-body class="pt-0" v-if="changedPlan">
                <button-loading class="btn btn-primary" @click="confirmUpdate">Update</button-loading>
            </card-body>
            <card-body class="pt-0" v-if="activePlan &amp;&amp; !changedPlan &amp;&amp; !deprecatedPlan">
                <button-loading class="btn btn-primary" @click="update" :loading="planForm.submitting">Resume
                </button-loading>
            </card-body>
            <modal ref="confirm" effect="none" @hidden="planForm.errors.forget()"><span
                    slot="title">Update Subscription</span>
                <div class="alert alert-danger mb-3" v-if="planForm.errors.any()">
                    <p class="font-weight-bold">The subscription update failed due to the errors below:</p>
                    <ul class="mb-0">
                        <li v-for="(error, index) of planForm.errors.all()" :key="index">{{ error[0] }}</li>
                    </ul>
                </div>
                <p class="m-0" v-if="selectedPlan">Are you sure you want to switch to the<b class="text-capitalize"> {{
                    selectedPlan.nickname }} / {{ selectedPlan.interval | interval(selectedPlan.interval_count) }}</b>?
                </p>
                <div slot="footer">
                    <button class="btn btn-default" @click="$refs.confirm.close()">No, Go Back</button>
                    <button-loading class="btn btn-primary ml-2" :loading="planForm.submitting" @click="update">Yes, I'm
                        Sure
                    </button-loading>
                </div>
            </modal>
        </card>
    </div>
</template>

<script>
    import UpdateSubscripton from './mixins/UpdateSubscription';

    export default {
        mixins: [
            UpdateSubscripton
        ],

        computed: {
            resumeOperationText() {
                return this.deprecatedPlan ?
                    'Please, choose one of the following plans to switch your plan subscription.' :
                    'You may resume your subscription at no extra cost until the end of the billing period.';
            },
        }
    };
</script>
